__turbopack_context__.v({
  "reaction": "WaveDropReactions-module-scss-module__EH_sCa__reaction",
  "reaction-slide-down": "WaveDropReactions-module-scss-module__EH_sCa__reaction-slide-down",
  "reaction-slide-up": "WaveDropReactions-module-scss-module__EH_sCa__reaction-slide-up",
  "reactionSlideDown": "WaveDropReactions-module-scss-module__EH_sCa__reactionSlideDown",
  "reactionSlideUp": "WaveDropReactions-module-scss-module__EH_sCa__reactionSlideUp",
});
